import React from 'react'

const Cancel = (props) => (
    <svg width="8" height="8" viewBox="0 0 8 8" fill={props ? props.color : '#EB5757'}
         xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd"
              d="M0.469938 0.469937C0.74063 0.199245 1.16533 0.178423 1.45972 0.40747L1.53044 0.469937L4.00019 2.93969L6.46994 0.469937C6.76319 0.176688 7.23719 0.176688 7.53044 0.469937C7.80113 0.74063 7.82195 1.16533 7.59291 1.45972L7.53044 1.53044L5.06069 4.00019L7.53044 6.46994C7.82369 6.76319 7.82369 7.23719 7.53044 7.53044C7.38419 7.67669 7.19219 7.75019 7.00019 7.75019C6.84019 7.75019 6.68019 7.69915 6.54666 7.5975L6.46994 7.53044L4.00019 5.06069L1.53044 7.53044C1.38419 7.67669 1.19219 7.75019 1.00019 7.75019C0.808187 7.75019 0.616187 7.67669 0.469938 7.53044C0.199245 7.25974 0.178423 6.83504 0.40747 6.54065L0.469938 6.46994L2.93969 4.00019L0.469938 1.53044C0.176688 1.23719 0.176688 0.763187 0.469938 0.469937Z"
              />
    </svg>
)

export default Cancel
